module.exports = __webpack_public_path__ + "fonts/opensans-regular-webfont.3de4b2d9.eot";